// extracted by mini-css-extract-plugin
export default {"content":"_404_content__0NEDe","pageTitle":"_404_pageTitle__XZ-ee","pageSubtitle":"_404_pageSubtitle__N4K2K","pageCTA":"_404_pageCTA__Dq8zr"};